import React, { useState, useEffect } from 'react';
import { history } from 'ice';
import $i18n from '../../../../i18n';
import { Card, Icon, Link, Loading } from '@b-design/fusion';
import PublishedAppLIstIcons from '@/components/PublishedAppListIcons';
import CreateMiniappDrawer from '@/components/CreateMiniappDrawer';
import ColorTags from '@/components/ColorTags';
import store from '@/store';
import { Field } from '@alifd/next';
import Requests from '@/services/request';
import { formatTime } from '@/utils';
import { getAppVersionStatus } from '@/utils/status';
import empty from '@/assets/overview/empty.svg';
import DefaultAppIcon from '@/components/DefaultAppIcon';
import './index.less';

const Miniapp: React.FC = () => {
  const field = Field.useField();
  const [userState] = store.useModel('user');
  const [spaceRoleState] = store.useModel('spaceRole');
  const [visible, setVisible] = useState(false);
  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [createTitle, setCreateTitle] = useState('');
  // const [editNameVisible, setEditNameVisible] = useState(false);
  const spaceId = spaceRoleState?.spaceId || '';

  const initData = async () => {
    if (!spaceId) {
      return;
    };
    setLoading(true);
    try {
      const spaceRole = await Requests.get('/rest/intercnn/space/query', { spaceIds: spaceId });
      const roleList = spaceRole?.list[0]?.role?.split(',') || [];
      let size = 8;
      if (roleList?.includes('ADMIN')) {
        size = 7;
      }
      const data = await Requests.get('/rest/intercnn/app/queryWithLatestPublishVersion', {
        spaceId,
        currentPage: 1,
        pageSize: size,
      });
      const { list = [] } = data;
      if (roleList?.includes('ADMIN')) {
        list.unshift({ appId: '0', title: 'add' });
      }
      setList(list);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   // 阿里云用户 && 已付费 && 存在默认空间 && 空间名称为空：弹框提示用户填写空间名称
  //   if (
  //     userState?.currentUser?.accountSrc === 'aliyun' &&
  //     userState?.currentUser?.isAliyunPaymentUser &&
  //     userState?.currentUser?.defaultSpace?.spaceId &&
  //     !userState?.currentUser?.defaultSpace?.spaceName
  //   ) {
  //     setEditNameVisible(true);
  //   }
  // }, [userState]);

  useEffect(() => {
    if (createTitle === 'createMiniapp') {
      initData();
      setCreateTitle('');
    }
  }, [createTitle]);

  useEffect(() => {
    if (!spaceId) return;
    initData();
  }, [spaceId]);

  const renderTag = (status) => {
    return <ColorTags tagTheme={status?.tagTheme} name={status?.name} width="100%" />;
  };

  return (
    <div className="overview-miniapp">
      <div className="overview-miniapp-title">
        <h1>{$i18n.get({ id: 'aopf.pages.overview.Miniapp', dm: '小程序' })}</h1>
        <Link
          onClick={() => {
            history?.push(`/miniapp?spaceId=${spaceId}`);
          }}
        >
          {$i18n.get({ id: 'aopf.pages.overview.Approvals.More', dm: '更多' })}
        </Link>
      </div>
      <Loading visible={loading} style={{ width: '100%' }}>
        <div
          className={`card-list ${
            spaceRoleState.roleList?.includes('DEVELOPER') && list.length === 0 ? 'developer-empty-container' : ''
          }`}
        >
          {/* 根据身份信息展示创建应用卡片 */}
          {spaceRoleState.roleList?.includes('DEVELOPER') && list.length === 0 ? (
            <div className="empty-app-container">
              <img src={empty} alt="" className="empty-img" />
              <div className="empty-app-msg">
                {$i18n.get({ id: 'aopf.pages.overview.empty.msg', dm: '请等待管理员分配MiniApp' })}
              </div>
            </div>
          ) : (
            list?.map((item, index) => (
              <React.Fragment key={index}>
                {spaceRoleState.roleList?.includes('ADMIN') && item?.appId === '0' ? (
                  <Card
                    free
                    style={{
                      width: '23.5%',
                      height: 320,
                      border: '1px dashed #d4d6e1',
                      marginRight: '2%',
                      cursor: 'pointer',
                    }}
                    key={item?.appId}
                    onClick={() => setVisible(true)}
                  >
                    <Card.Content
                      style={{
                        height: '100%',
                        marginTop: 0,
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <div className="create-container">
                        <div className="create-icon">
                          <span className="superapp_iconfont superapp_icon-jiahao" />
                        </div>
                        <div className="create-title">
                          {$i18n.get({
                            id: 'aopf.pages.overview.Create.Miniapp',
                            dm: '创建小程序',
                          })}
                        </div>
                      </div>
                    </Card.Content>
                  </Card>
                ) : (
                  <Card
                    free
                    style={{
                      width: '23.5%',
                      height: 320,
                      marginBottom: 24,
                      marginRight: (index + 1) % 4 === 0 ? 0 : '2%',
                    }}
                    key={item?.appId}
                    id="card-list-container"
                    onClick={() =>
                      history?.push(`/miniapp/detail?spaceId=${spaceId}&appId=${item.appId}`)
                    }
                  >
                    <Card.Content
                      style={{
                        height: '100%',
                        marginTop: 0,
                        padding: '16px',
                      }}
                    >
                      <div className="superapp_icon-btn-right superapp_icon-btn-right-hiden">
                        <Icon type="arrow--right" size="medium" />
                      </div>
                      {item.description?.iconPublicUrl ? (
                        <img src={item.description?.iconPublicUrl} alt="" className="card-icon" />
                      ) : (
                        <DefaultAppIcon className="card-icon" />
                      )}

                      <div className="card-title">{item.description?.name}</div>
                      <div className="card-version">{`${$i18n.get({
                        id: 'aopf.pages.miniapp.version.info.Version',
                        dm: '版本',
                      })} ${item.maxVersion ? item.maxVersion : ''}`}</div>
                      <div className="card-detail">
                        <div className="left">
                          {$i18n.get({ id: 'aopf.pages.overview.Publish.App', dm: '发布应用' })}
                          {item.latestPublishVersion?.channelIcon ? (
                            <div className="left-div-container-publish">
                              <PublishedAppLIstIcons
                                value={[item.latestPublishVersion?.channelIcon]}
                              />
                            </div>
                          ) : (
                            <div className="left-div-publish-icon">-</div>
                          )}
                        </div>
                        <div className="right">
                          {$i18n.get({ id: 'aopf.pages.overview.Last.Modified', dm: '最后修改' })}
                          <div className="right-modified-time">
                            {formatTime(item.description?.gmtModified)}
                          </div>
                        </div>
                      </div>
                      <div className="card-status">
                        {item.latestPublishVersion?.versionStatus
                          ? renderTag(getAppVersionStatus(item.latestPublishVersion?.versionStatus))
                          : null}
                      </div>
                    </Card.Content>
                  </Card>
                )}
              </React.Fragment>
            ))
          )}
        </div>
      </Loading>
      <CreateMiniappDrawer
        visible={visible}
        setVisible={setVisible}
        setCreateTitle={setCreateTitle}
        status="create"
      />
    </div>
  );
};

export default Miniapp;
